var React = require('react');

function TriangleWhatsappForm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M499.355 335.574L471.289 59.4613M499.355 335.574L288.037 179.579M499.355 335.574L24.1516 106.752M471.289 59.4613L288.037 179.579M471.289 59.4613L24.1516 106.752M288.037 179.579L24.1516 106.752","stroke":"#E5E5E5"}));
}

TriangleWhatsappForm.defaultProps = {"width":"536","height":"337","viewBox":"0 0 536 337","fill":"none"};

module.exports = TriangleWhatsappForm;

TriangleWhatsappForm.default = TriangleWhatsappForm;
